export const aButton = () => {
  /**
   * When a paragraph only contains buttons, we need to apply styles to that paragraph
   */
  const handleParagraphs = () => {
    const paragraphs: HTMLParagraphElement[] = Array.from(
      document.querySelectorAll('p')
    );
    paragraphs.forEach((paragraph) => {
      const children = Array.from(paragraph.children);

      if (children.length > 1) {
        if (children.find((x) => x.classList.contains('button'))) {
          // Remove unnessessary non breaking spaces that Craft creates when the user hits the spacebar too often
          paragraph.innerHTML = paragraph.innerHTML.replace(/&nbsp;/g, '');
        }
      }
    });
  };

  const handleButtonArrow = () => {
    const arrowIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"><path fill="currentColor" d="M16.175 13.5H5a.967.967 0 0 1-.713-.287A.968.968 0 0 1 4 12.5c0-.283.096-.52.287-.713A.967.967 0 0 1 5 11.5h11.175l-4.9-4.9a.916.916 0 0 1-.287-.7c.008-.267.112-.5.312-.7.2-.183.433-.28.7-.288.267-.008.5.088.7.288l6.6 6.6c.1.1.17.208.212.325.042.117.063.242.063.375s-.02.258-.063.375a.877.877 0 0 1-.212.325l-6.6 6.6a.933.933 0 0 1-.688.275c-.274 0-.512-.092-.712-.275-.2-.2-.3-.438-.3-.713 0-.274.1-.512.3-.712l4.875-4.875Z"/></svg>
    `;

    const buttons: (HTMLButtonElement | HTMLAnchorElement)[] = Array.from(
      document.querySelectorAll(
        `.button--primary:not(:has([is='atom-icon'])), .button--secondary:not(:has([is='atom-icon'])), .button--tertiary:not(:has([is='atom-icon']))`
      )
    );

    buttons
      .filter((x) => !x.classList.contains('button--no-icon'))
      .forEach((button) => {
        const iconWrapper = document.createElement('span');
        iconWrapper.classList.add('iconWrapper');
        iconWrapper.innerHTML = arrowIcon;
        iconWrapper.setAttribute('aria-hidden', 'true');
        button.append(iconWrapper);
      });
  };

  handleParagraphs();
  handleButtonArrow();
};
